export async function fetchSepaVerify(
  locale: string,
  iban?: string,
  accountHolder?: string,
  sepaVerifyTimestamp?: string
) {
  const baseUrl = window.location.href.split('?')[0]
  return await $fetch
    .raw('/customer/sepa/verify', {
      baseURL: useRuntimeConfig().public.apiBaseURL,
      method: 'POST',
      body: {
        name: accountHolder,
        iban: iban,
        backUrl: `${baseUrl}?sepa-verify=back&ts=${sepaVerifyTimestamp}`,
        successUrl: `${baseUrl}?sepa-verify=success&ts=${sepaVerifyTimestamp}`,
        errorUrl: `${baseUrl}?sepa-verify=error&ts=${sepaVerifyTimestamp}`,
        language: locale,
      },
    })
    .catch((error) => {
      return error.data
    })
}
